import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { sendFormspree } from '../../utils/formspree';
import './style.css';

const ContactForm = () => {
  const { t } = useTranslation('contacts');

  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [message, setMessage] = useState('');

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');

    try {
      await sendFormspree({ source: 'Contact Form', name, email, phone, message });
      setSubmitSuccess(true);
    } catch {
      setSubmitError(t('form.error'));
    } finally {
      setIsSubmitting(false);
    }
  };

  if (submitSuccess) {
    return (
      <div className="success-message">
        <h3>{t('form.successTitle')}</h3>
        <p>{t('form.successDesc')}</p>
        <button className="button" onClick={() => setSubmitSuccess(false)}>
          {t('form.successClose')}
        </button>
      </div>
    );
  }

  return (
    <form className="contact-form" onSubmit={handleSubmit}>
      <div className="form-group">
        <label htmlFor="name" className="form-label">{t('form.name')}</label>
        <input
          id="name"
          type="text"
          required
          className="form-input"
          value={name}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label htmlFor="email" className="form-label">{t('form.email')}</label>
        <input
          id="email"
          type="email"
          required
          className="form-input"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label htmlFor="phone" className="form-label">{t('form.phone')}</label>
        <input
          id="phone"
          type="tel"
          required
          className="form-input"
          value={phone}
          onChange={(e) => setPhone(e.target.value)}
        />
      </div>
      <div className="form-group">
        <label htmlFor="message" className="form-label">{t('form.message')}</label>
        <textarea
          id="message"
          rows={4}
          className="form-textarea"
          value={message}
          onChange={(e) => setMessage(e.target.value)}
        />
      </div>
      <button type="submit" className="button" disabled={isSubmitting}>
        {isSubmitting ? t('form.submitting') : t('form.submit')}
      </button>
      {submitError && <p className="error-text">{submitError}</p>}
      <p className="note-text">{t('form.notePrivate')}</p>
    </form>
  );
};

export default ContactForm;